<template>
  <div class="md-layout" v-if="extra">
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <div class="card-icon">
          <md-icon>info</md-icon>
        </div>
        <h4 class="title">
          Details
        </h4>
      </md-card-header>
      <md-card-content>
        <form>
          <div class="md-layout">
            <div class="md-layout-item md-size-100 mb-4">
              <md-field>
                <label>Title</label>
                <md-input
                  v-model="extra.title"
                  type="text"
                  ref="title"
                ></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-100">
              <label
                class="caption"
                style="margin-bottom:0.5rem; display:block;"
                >Description</label
              >
              <text-editor v-model="extra.description" />
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <h6>Default Pricing</h6>
            </div>

            <div class="md-layout-item md-size-33 price-row">
              <md-field class="md-form-group" slot="inputs">
                <md-icon
                  ><i class="fas fa-pound-sign text-primary hi-price-icon"></i
                ></md-icon>
                <label>GBP</label>
                <md-input v-model="extra.prices.gbp" type="text"></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-33 price-row">
              <md-field class="md-form-group" slot="inputs">
                <md-icon
                  ><i class="fas fa-euro-sign text-primary hi-price-icon"></i
                ></md-icon>
                <label>EUR</label>
                <md-input v-model="extra.prices.eur" type="text"></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-33 price-row">
              <md-field class="md-form-group" slot="inputs">
                <md-icon
                  ><i class="fas fa-dollar-sign text-primary hi-price-icon"></i
                ></md-icon>
                <label>USD</label>
                <md-input v-model="extra.prices.usd" type="text"></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-33">
              <md-switch v-model="extra.saleable">Saleable</md-switch>
            </div>
            <div class="md-layout-item md-size-33">
              <md-switch v-model="extra.public">Public</md-switch>
            </div>
            <div class="md-layout-item md-size-33">
              <md-switch v-model="extra.compulsory">Compulsory</md-switch>
            </div>

            <div class="md-layout-item md-size-100 created-date">
              <div class="md-caption">Created On</div>
              <div class="">{{ extra.created_at | formatDate }}</div>
            </div>
          </div>

          <div class="md-layout" id="options">
            <div class="md-layout-item md-size-90">
              <h6>Options</h6>
            </div>
            <div class="md-layout-item md-size-10 text-right">
              <md-button
                class="md-icon-button md-dense md-primary md-round"
                @click="showOptionDialog"
              >
                <md-icon>add</md-icon>
                <md-tooltip md-direction="top">Add an Option</md-tooltip>
              </md-button>
            </div>
          </div>

          <extra-option-dialog
            v-bind:showExtraOptionDialog="showExtraOptionDialog"
            v-on:create="addOption"
            v-on:cancel="showExtraOptionDialog = false"
          />

          <template v-if="extra.options && extra.options.length">
            <extra-option
              v-for="(option, index) in extra.options"
              v-bind:key="option.id"
              v-bind:option="option"
              v-bind:index="index"
              v-on:deleteOption="deleteOption"
            ></extra-option>
          </template>

          <div class="md-layout">
            <div class="md-layout-item md-size-100 text-right">
              <md-button
                class="md-raised md-success mt-4"
                @click.prevent="update"
                >{{ updateButtonText }}</md-button
              >
            </div>
          </div>
        </form>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import extraApi from "@/services/api/extra";

import _filter from "lodash/filter";
import _findIndex from "lodash/findIndex";

import ExtraOption from "./ExtraOption";
import ExtraOptionDialog from "./ExtraOptionDialog";

export default {
  props: ["extra"],

  data() {
    return {
      showExtraOptionDialog: false,
      option: {}
    };
  },

  components: {
    ExtraOption,
    ExtraOptionDialog
  },

  computed: {
    updateMode: function() {
      return this.extra.id ? "UPDATE" : "CREATE";
    },
    updateButtonText: function() {
      return this.updateMode == "UPDATE" ? "Update" : "Add";
    }
  },

  methods: {
    update() {
      let save = null;
      let message = "";

      switch (this.updateMode) {
        case "UPDATE":
          save = extraApi.update(this.extra);
          message = "Updated!";
          break;

        default:
          save = extraApi.create(this.extra);
          message = "Added!";
      }

      save.then(response => {
        this.$notify({
          timeout: 2500,
          message: message,
          icon: "thumb_up",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success"
        });

        this.$emit("extraUpdated", {
          extra: response.data,
          mode: this.updateMode
        });
      });
    },

    addOption(option) {
      // this.extra.options.push({});
      // this.showExtraOptionDialog = false;
    },

    deleteOption(args) {
      if (args.option.id) {
        extraApi.deleteOption(this.extra, option).then(response => {
          this.extra.options = _filter(this.extra.options, function(item) {
            return item.id !== option.id;
          });
        });
      } else {
        this.extra.options.splice(args.index, 1);
      }
    },

    showOptionDialog() {
      this.extra.options.push({});
      //this.showExtraOptionDialog = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.created-date {
  margin-top: 1em;
}
#options {
  border-top: 1px solid #00bcd4;
  margin-top: 1em;
}

.price-row {
  margin-bottom: 1rem;
}

.mb-4 {
  margin-bottom: 1rem;
}
</style>
